export const getTutorialDaysString = (data: any) => {
  const tutorial_days = [];
  data.tutorial_day1 && tutorial_days.push("Aug 15th");
  data.tutorial_day2 && tutorial_days.push("Aug 16th");
  data.tutorial_day3 && tutorial_days.push("Aug 17th");

  return tutorial_days.length > 0 ? tutorial_days.join(", ") : "None";
};

export const getWorkshopDaysString = (data: any) => {
    const worksyhop_days = [];
    data.workshop_day1 && worksyhop_days.push("Aug 15th");
    data.workshop_day2 && worksyhop_days.push("Aug 16th");
    data.workshop_day3 && worksyhop_days.push("Aug 17th");

    return worksyhop_days.length > 0 ? worksyhop_days.join(", ") : "None";
  };
